export const RECEIVABLES_STRUCTURE = {
  lastUpdatedAt: null,
  receivables: {
    totalAmount: '-',
    outstandingAmount: '-',
    overDueAmount: '-',
    outstandingAmountPercent: 0,
    overDueAmountPercent: 0,
  },
  accountsReceivablesAging: {
    day30: '-',
    day60: '-',
    day90: '-',
    day120: '-',
    above120: '-',
    seriesData: [],
    segmentation: [],
    totalAmount: 0,
    unDue: 0,
    overDue: 0,
  },
};

export const COLLECTIONS_STRUCTURE = {
  lastUpdatedAt: '-',
  collections: {
    totalAmount: 0,
    percentChange: 0,
    data: [],
    segmentation: [],
  },
  billedVsPaid: {
    labels: [],
    values: { billed: [], paid: [], pastDue: [] },
    difference: {
      billed: 0,
      paid: 0,
      pastDue: 0,
    },
  },
  validatedContracts: [],
};

export const PROJECTIONS_STRUCTURE = {
  lastUpdatedAt: '-',
  projectedCashflow: {
    labels: [],
    values: [],
  },
  futureDeed: {
    labels: [],
    values: [],
  },
};

export const DASHBOARD_COLORS = {
  RECEIVABLES: {
    HEADER: '#EAFCFF',
    OUTSTANDING: '#40D8F1',
    OVERDUE: '#F93F3F',
  },
  COLLECTIONS: '#F1FFF2',
  AR_SEGMENT: {
    Funeral: 'red',
  },
  AR_AGING: ['#58E3DB'],
  BILLED_VS_PAID: ['#8bc34a', '#466225', '#d63535'],
  FUTURE_PAID_IN_FULL: ['#a3006b'],
  PROJECTED_CASHFLOW: ['#EED202'],
};

export const DURATION = {
  SINGLE: 'SINGLE',
  PAST: 'PAST_DURATION',
  FUTURE: 'FUTURE_DURATION',
};

export const VALIDATED_CONTRACTS_HEADERS = [
  'Purchaser \n/ OPI #ID',
  'Contract \n/ Statement',
  'Date of \nTransaction',
  'Due Amount \n/ Total Paid',
  'Payment',
];

export const BUSINESS_UNIT_COLORS = {
  Funeral: '#EE8BAA',
  Cemetery: '#5048AC',
  'Wholesale Cremation': '#a3006b',
  'Miscellaneous Sales': '#A7A3DE',
  'Travel Protection Insurance': '#08ACE1',
  Cremation: '#ECE534',
  // New BU's
  CLC: '#5048AC',
  CFS: '#EE8BAA',
  CCS: '#ECE534',
  PNF: '#A7A3DE',
};

export const AN_PN_COLORS = {
  'At-Need': '#4894AC',
  'Pre-Need': '#ECE434',
};

export const POSITIVE_MIN = 9999;
export const NEGATIVE_MIN = -9999;

export const currencyFormatter = (num) => {
  if (typeof num !== 'number') return '';
  const fmt = new Intl.NumberFormat('en-US', {
    currency: 'USD',
    style: 'currency',
    useGrouping: true,
    maximumFractionDigits: 2,
  });
  return fmt.format(num);
};

export const currencyFormatterInShort = (num, short = false) => {
  const fmt = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'USD',
  });
  const isValid = num > POSITIVE_MIN || num < NEGATIVE_MIN;
  if (typeof num !== 'number') return '';
  if (isValid) {
    const isLessThanMillion = num < 1e6;
    const _num = isLessThanMillion ? num / 1e6 : num;
    return isLessThanMillion ? `${fmt.format(_num)}M` : fmt.format(_num);
  }
  if (!isValid && short) return fmt.format(num);
  return currencyFormatter(num);
};

export const dashboardFiltersPrefixedData = {
  entity: [],
  businessUnits: [],
  salesManagers: [],
  unitManagers: [],
  departments: [],
};
